import React, { lazy, Suspense, useEffect, useState } from "react";
import OverlayHome from "./components/OverlayHome";
import { Helmet } from "react-helmet";
import styles from "./HomePageMain.module.css";
import style from "./components/Css/Homestyles.module.css";
import Loading from "../common/HousGlass Loader/Loading";
import { getPageMetaById } from '../api/PageMetaManager';

const FeaturedCollections = lazy(() =>
  import("./components/FeaturedCollections")
);
const TrendingNow = lazy(() => import("./components/TrendingNow"));
const AudioSeries = lazy(() => import("./components/AudioSeries"));
const EbooksHome = lazy(() => import("./components/EbooksHome"));
const Top10AudioSeries = lazy(() => import("./components/TopTenAudioSeries"));
const Footer = lazy(() => import("../common/UI/Footer"));
const NewsLetter = lazy(() => import("../common/UI/NewsLetter"));
const SeriesTopTen = lazy(() => import("./components/SeriesTopTen"));
const ImageSliderr = lazy(() => import("./components/SliderHomepage"));
const PodcastCarousel = lazy(() => import("./components/PodcastCarousel"));

const DocumentarySection = lazy(() =>
  import("../pages/video-pages/DocumentarySection")
);
const KidStoriesSection = lazy(() =>
  import("../pages/video-pages/KidStoriesSection")
);
const GarhwaliCarousel = lazy(() => import("./components/GarhwaliScroller"));
const RecentlyAddedCarousel = lazy(() =>
  import("./components/RecentlyUploaded")
);
const Banner = lazy(() => import("./components/BannerPage"));
const ShortStoriesCarousel = lazy(() =>
  import("./components/ShortStoriesCategories")
);

function Homepage() {

  const [meta, setMeta] = useState({
    title: "",
    description: "",
    keywords: ""
  });

  useEffect(() => {
    const fetchMeta = async () => {
      try {
        const data = await getPageMetaById(1);
        setMeta({
          title: data.meta_title || '',
          description: data.meta_description || '',
          keywords: data.meta_keywords || ''
        });
      } catch (error) {
        console.warn('Meta not found for home page, using defaults');
      }
    };

    fetchMeta();
  }, []);

  return (
    <>
      <Helmet>
        <title>{meta.title || 'Home - SunoKahaniyan'}</title>
        <meta
          name="description"
          content={
            meta.description ||
            'Explore a wide range of audio stories, ebooks, and videos on SunoKahaniyan. Discover trending collections, recently added content, and much more!'
          }
        />
        <meta name="keywords" content={meta.keywords || 'audio stories, ebooks, videos, hindi kahaniyan, suno kahaniyan'} />
      </Helmet>
      <div className={style.homeBackground}>
        <OverlayHome type={"Home"} category={"audio"} />
        <div className={`${styles.homepageContainer} ${styles.contentOverlap}`}>
          <Suspense
            fallback={
              <div
                style={{
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Loading />
              </div>
            }
          >
            <FeaturedCollections />
            <RecentlyAddedCarousel />
            <Banner
             rank={1}
            />
            <TrendingNow />
            <AudioSeries />
            <Banner
            rank={2}
            />

            <ImageSliderr />
            <EbooksHome />
            <Banner
              rank={3}
            />
            <ShortStoriesCarousel category={"Drama"} />
            <PodcastCarousel category={"Podcast"} />


            <GarhwaliCarousel language={"garhwali"} />
            <DocumentarySection />
            <Banner
             rank={4}
            />
            <ShortStoriesCarousel category={"Horror"} />

            <Top10AudioSeries />

            <ShortStoriesCarousel category={"Crime"} />

            <KidStoriesSection />
            <NewsLetter />
            <Footer />
          </Suspense>
        </div>
      </div>
    </>
  );
}

export default Homepage;
